import { Link as ChakraLink } from '@chakra-ui/react'

export const Link = ChakraLink
